import React from 'react'
import {Box, Chip} from '@mui/material'
import {Typography} from '../../../webui/Typography'
import {classifyOpeningWindow, describeOpeningWindow, getStockholmNowMinutes, isOpenNow} from '../utils/openingHours'

interface OpeningHoursPreviewProps {
  start: string
  end: string
}

/**
 * Live, read-only summary shown beneath the open/close time inputs:
 * a timezone note, the interpreted window (same-day / overnight / 24h) and an
 * "open now" chip evaluated in Europe/Stockholm — mirroring how the app decides
 * open/closed from these two fields.
 */
export const OpeningHoursPreview: React.FC<OpeningHoursPreviewProps> = ({start, end}) => {
  const kind = classifyOpeningWindow(start, end)
  const open = kind === 'invalid' ? null : isOpenNow(start, end, getStockholmNowMinutes())

  return (
    <Box mt={1} display="flex" flexDirection="column" gap={0.5}>
      <Typography variant="caption" color="text.secondary">
        Times are Europe/Stockholm wall-clock time.
      </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2" color={kind === 'invalid' ? 'error' : 'text.primary'}>
          {describeOpeningWindow(start, end)}
        </Typography>
        {open !== null && (
          <Chip size="small" label={open ? 'Open now' : 'Closed now'} color={open ? 'success' : 'default'} variant={open ? 'filled' : 'outlined'} />
        )}
      </Box>
    </Box>
  )
}
